import React from 'react';

function MarketplaceCloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20">
      <path
        fill="#151035"
        d="M15.775 15.777a.856.856 0 01-1.21 0L10 11.212l-4.565 4.565a.856.856 0 11-1.21-1.21l4.565-4.565-4.564-4.565a.856.856 0 011.21-1.21L10 8.792l4.565-4.565a.856.856 0 111.21 1.21l-4.565 4.565 4.565 4.564a.855.855 0 010 1.21z"
      />
    </svg>
  );
}

export default MarketplaceCloseIcon;
